import { render } from "./NavInventoryItem.vue?vue&type=template&id=f525e282"
import script from "./NavInventoryItem.vue?vue&type=script&lang=js"
export * from "./NavInventoryItem.vue?vue&type=script&lang=js"
script.render = render

export default script